import { LanguageService } from '../service/language.service';
import { FilterService } from '../generic/service/filter.service';
import { FavoriteService } from '../generic/service/favorite.service';
import { OrderHistoryService } from '../service/order.history.service';
import { BarcodeService } from '../service/barcode.service';
import { ProductService } from '../generic/service/product.service';
import { LoggedInGuardService } from '../security/logged-in.guard.service';
import { AlreadyLoggedInGuardService } from '../security/already-logged-in.guard.service';
import { LoggedInMandatoryGuardService } from '../security/logged-in-mandatory-guard.service';
import { AssortmentBannerService } from '../service/assortment.banner.service';
import { BlogService } from '../service/blog.service';
import { HuntersService } from '../service/hunters.service';
import { ResizeService } from '../service/rezise.service';
import { ShipmentLineService } from '../generic/service/shipmentline.service';
import { MyFavoritesGuardService } from '../security/my-favorites.guard.service';
import { ProductHistoryGuardService } from '../security/product-history.guard.service';
import { ClaimService } from '../service/claim.service';


export const applicationServices = [
    LanguageService,
    FilterService,
    LoggedInGuardService,
    AlreadyLoggedInGuardService,
    LoggedInMandatoryGuardService,
    FavoriteService,
    OrderHistoryService,
    AssortmentBannerService,
    BarcodeService,
    ProductService,
    HuntersService,
    BlogService,
    ShipmentLineService,
    ResizeService,
    MyFavoritesGuardService,
    ProductHistoryGuardService,
    ClaimService,
];
